// extracted by mini-css-extract-plugin
export var arrowLink = "NotificationBar-module--arrow-link--69fb7";
export var crossIcon = "NotificationBar-module--crossIcon--bd738";
export var hide = "NotificationBar-module--hide--aa6fb";
export var notifyBar = "NotificationBar-module--notifyBar--3925b";
export var notifyBarText = "NotificationBar-module--notifyBarText--4a1ca";
export var show = "NotificationBar-module--show--cb905";